module.exports = __webpack_public_path__ + "img/奖章5级@3x.af57c82d.png";